(function () {
  function computePercent(variant) {
    if (!variant || !variant.compare_at_price) return 0;
    if (variant.price <= 0 || variant.compare_at_price <= variant.price) return 0;
    return Math.round((1 - variant.price / variant.compare_at_price) * 100);
  }

  function updateBadge(variant) {
    const badge = document.querySelector('#product-media [data-cf-sale-badge]');
    if (!badge) return;
    const textEl = badge.querySelector('.cf-sale-badge__text');
    if (!textEl) return;

    if (badge.dataset.cfSaleType === 'percent') {
      const pct = computePercent(variant);
      if (pct > 0) {
        const template = badge.dataset.cfSalePercentTemplate || '-__PCT__%';
        textEl.textContent = template.replace('__PCT__', pct);
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
      return;
    }

    // Money / sale modes: hide when the picked variant isn't on sale,
    // otherwise leave the initial server-rendered text in place.
    if (variant && variant.compare_at_price > variant.price && variant.price > 0) {
      badge.hidden = false;
    } else if (variant) {
      badge.hidden = true;
    }
  }

  document.addEventListener('on:variant:change', (evt) => {
    updateBadge(evt.detail && evt.detail.variant);
  });

  // Spool-it reels (product.reels-spool-option-set) use a custom select
  // (snippets/spool-product-options.liquid) that does NOT dispatch
  // on:variant:change. Read its dataset attrs and build a synthetic variant.
  document.addEventListener('change', (evt) => {
    const t = evt.target;
    if (!(t instanceof HTMLSelectElement) || t.id !== 'main_variant_select') return;
    const opt = t.options[t.selectedIndex];
    if (!opt) return;
    const price = parseInt(opt.dataset.price, 10) || 0;
    const compare = parseInt(opt.dataset.compare, 10) || 0;
    updateBadge({ price: price, compare_at_price: compare });
  });
})();
